module.exports = __webpack_public_path__ + "static/media/confirm-agreement.f1033550.svg";